import { useState } from "react";
import { Loader2, PlugZap } from "lucide-react";
import { xc, errMsg } from "@/lib/xc";

const Field = ({ label, ...p }) => (
  <label className="block">
    <span className="xc-label">{label}</span>
    <input {...p} className="xc-input mt-1.5" />
  </label>
);

export default function AccountForm({ onSave }) {
  const [f, setF] = useState({ name: "", server: "", username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (acc) => {
    setBusy(true);
    setError(null);
    try {
      const d = await xc({ ...acc, id: "test" }, "");
      if (!d?.user_info || String(d.user_info.auth) !== "1") throw new Error("auth");
      onSave({ ...acc, name: acc.name || acc.username });
    } catch (e) {
      setError(e.message === "auth" ? "Login failed. Check the server URL, username and password." : errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit(f);
      }}
      className="space-y-4"
      data-testid="account-form"
    >
      <Field label="Playlist name" placeholder="My IPTV" value={f.name} onChange={set("name")} data-testid="account-name-input" />
      <Field label="Server URL" placeholder="http://example.com:8080" required value={f.server} onChange={set("server")} data-testid="account-server-input" />
      <div className="grid grid-cols-2 gap-3">
        <Field label="Username" required value={f.username} onChange={set("username")} data-testid="account-username-input" />
        <Field label="Password" type="password" required value={f.password} onChange={set("password")} data-testid="account-password-input" />
      </div>
      {error && (
        <p className="text-sm text-[#FF5A62]" data-testid="account-form-error">
          {error}
        </p>
      )}
      <div className="flex flex-wrap gap-3 pt-1">
        <button type="submit" disabled={busy} className="xc-btn-primary" data-testid="account-save-button">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <PlugZap className="w-4 h-4" />}
          Connect & save
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={() => submit({ name: "Demo playlist", server: "demo", username: "demo", password: "demo" })}
          className="xc-btn-ghost"
          data-testid="account-demo-button"
        >
          Try the demo playlist
        </button>
      </div>
    </form>
  );
}
